import { lazy } from 'react';

export const IntegrationPageAsync = lazy(() => import('./IntegrationPage'));
